import { z } from "zod";

export const attributeOptionSchema = z
  .object({
    optionId: z.string().optional(),
    name: z.string(),
    value: z.string(),
    delete: z.boolean().optional(),
  })
  .refine((data) => data.delete || data.name.length > 0, {
    message: "Option name is required",
    path: ["name"],
  })
  .refine((data) => data.delete || data.value.length > 0, {
    message: "Option value is required",
    path: ["value"],
  });

export const variantAttributeSchema = z.object({
  name: z.string().min(1, "Name is required").max(100, "Name is too long"),
  description: z.string().optional(),
  options: z
    .array(attributeOptionSchema)
    .refine((options) => options.some((o) => !o.delete), {
      message: "At least one option is required",
    }),
});

export type VariantAttributeFormData = z.infer<typeof variantAttributeSchema>;
export type AttributeOptionFormData = z.infer<typeof attributeOptionSchema>;
